/**
 * Shared Modal Styles
 * Consistent styling constants for all modal components across the dashboard
 */

import type { CSSProperties } from 'react';

// Backdrop/Overlay
export const MODAL_BACKDROP_STYLE: CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
};

// Modal Container (default width)
export const MODAL_CONTAINER_STYLE: CSSProperties = {
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  padding: '32px',
  maxWidth: '600px',
  width: '90%',
  maxHeight: '90vh',
  overflow: 'auto',
  boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
};

// Modal Title
export const MODAL_TITLE_STYLE: CSSProperties = {
  fontSize: '24px',
  fontWeight: '700',
  marginBottom: '16px',
  color: '#111827',
  margin: '0 0 16px 0',
};

// Form Group
export const FORM_GROUP_STYLE: CSSProperties = {
  marginBottom: '16px',
};

// Label
export const LABEL_STYLE: CSSProperties = {
  display: 'block',
  fontSize: '14px',
  fontWeight: '500',
  color: '#374151',
  marginBottom: '8px',
  margin: '0 0 8px 0',
};

// Input/Select
export const INPUT_STYLE: CSSProperties = {
  width: '100%',
  padding: '12px',
  fontSize: '14px',
  border: '1px solid #d1d5db',
  borderRadius: '6px',
  outline: 'none',
  boxSizing: 'border-box',
  height: '44px',
  display: 'block',
  margin: 0,
};

// Textarea
export const TEXTAREA_STYLE: CSSProperties = {
  width: '100%',
  padding: '12px',
  fontSize: '14px',
  border: '1px solid #d1d5db',
  borderRadius: '6px',
  outline: 'none',
  boxSizing: 'border-box',
  display: 'block',
  margin: 0,
  resize: 'vertical' as const,
};

// Button Container
export const BUTTON_GROUP_STYLE: CSSProperties = {
  display: 'flex',
  gap: '12px',
  justifyContent: 'flex-end',
  marginTop: '24px',
};

// Buttons
export const PRIMARY_BUTTON_STYLE: CSSProperties = {
  padding: '12px 24px',
  fontSize: '14px',
  fontWeight: '600',
  color: '#ffffff',
  backgroundColor: '#3b82f6',
  border: 'none',
  borderRadius: '6px',
  cursor: 'pointer',
};

export const SECONDARY_BUTTON_STYLE: CSSProperties = {
  padding: '12px 24px',
  fontSize: '14px',
  fontWeight: '600',
  color: '#374151',
  backgroundColor: '#f3f4f6',
  border: '1px solid #d1d5db',
  borderRadius: '6px',
  cursor: 'pointer',
};

export const DANGER_BUTTON_STYLE: CSSProperties = {
  padding: '12px 24px',
  fontSize: '14px',
  fontWeight: '600',
  color: '#ffffff',
  backgroundColor: '#dc2626',
  border: 'none',
  borderRadius: '6px',
  cursor: 'pointer',
};

export const WARNING_BUTTON_STYLE: CSSProperties = {
  padding: '12px 24px',
  fontSize: '14px',
  fontWeight: '600',
  color: '#ffffff',
  backgroundColor: '#f59e0b',
  border: 'none',
  borderRadius: '6px',
  cursor: 'pointer',
};

// Error Message
export const ERROR_MESSAGE_STYLE: CSSProperties = {
  padding: '12px',
  backgroundColor: '#fef2f2',
  border: '1px solid #fecaca',
  borderRadius: '6px',
  color: '#dc2626',
  fontSize: '14px',
  marginBottom: '16px',
};

// Success Message
export const SUCCESS_MESSAGE_STYLE: CSSProperties = {
  padding: '12px',
  backgroundColor: '#d1fae5',
  border: '1px solid #10b981',
  borderRadius: '6px',
  color: '#065f46',
  fontSize: '14px',
  marginBottom: '16px',
};

// Warning Message
export const WARNING_MESSAGE_STYLE: CSSProperties = {
  padding: '12px',
  backgroundColor: '#fef3c7',
  border: '1px solid #fbbf24',
  borderRadius: '6px',
  color: '#92400e',
  fontSize: '14px',
  marginBottom: '16px',
};
